import React from 'react';
import './App.css';
import { Navigate, Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import { routes } from './routes';
import { useGlobalState } from "./Context/GlobalStateContext";
import { getLandingPath, hasModuleAccess, isAdminCompany } from "./Utils/modulos";

function App() {
  const { userData } = useGlobalState();
  const hasSession = Boolean(userData?.empresaId || localStorage.getItem("empresaid"));
  const landingPath = getLandingPath(userData);

  return (
    <div className="App">
      <Router>
        <Routes>
          {routes.map((route, index) => (
            <Route
              key={index}
              exact
              path={route.path}
              element={
                route.path === "/"
                  ? route.component
                  : !hasSession
                    ? <Navigate to="/" replace />
                    : route.adminOnly
                      ? isAdminCompany(userData)
                        ? route.component
                        : <Navigate to={landingPath} replace />
                      : route.module
                        ? hasModuleAccess(userData, route.module)
                          ? route.component
                          : <Navigate to={landingPath} replace />
                        : route.component
              }
            />
          ))}
        </Routes>

      </Router>
    </div>
  );
}

export default App;
